// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2414":"d3461e24f162491c","3877":"fe336940f98fdfab","6272":"aa4472f7082b94cd","7584":"a5f0c83ca3a862b0","8245":"8f4c22cd6e235e7f"}[chunkId] + ".css";
};